/* eslint-disable */
import HttpService from '../HttpService'

export default class MovementAssignmentService {
  constructor() {
    this._httpMovementRecordService = new HttpService('/sdi-bff/movement-record');
    this._httpFileService = new HttpService('/sdi-bff/file');
    this._httpServiceUnitService = new HttpService('/sdi-bff/service-unit');
  }

  async assignToMe(movementRecordId) {
    return await this.assignMovements({ movementIds: [movementRecordId] });
  }

  async assignToUser(movementRecordId, userId) {
    return await this.assignMovements({ movementIds: [movementRecordId], userId });
  }

  async bulkAssign(data) {
    return await this.assignMovements(data);
  }

  async assignMovements(data) {
    return await this._httpMovementRecordService.post('/assign', data);
  }

  async getStructuresByMovementIds(movementIds) {
    return await this.getAvailableUnits(movementIds);
  }

  async getAvailableUnits() {
    return await this._httpServiceUnitService.get('/available-units');
  }

  async getResponsibleUsers(structureIds) {
    if (Array.isArray(structureIds) && structureIds.length > 0) {
      return await this._httpServiceUnitService.post('/responsible-users', { structure_ids: structureIds });
    }

    return await this._httpServiceUnitService.post('/responsible-users');
  }

  async getUsersByStructure(structureId) {
    return await this.getResponsibleUsers(structureId ? [structureId] : []);
  }

  async reassign(movementRecordId, userId) {
    return await this.assignToUser(movementRecordId, userId);
  }

  async fileAssignToMe(fileDataId) {
    return await this._httpFileService.post('/assign', { fileId: fileDataId });
  }
}
